import React from "react";
import {
    CloseProgressStatus,
    closeProgressStatusLabels,
} from "@common/types/closeProgress";
import { BaseFilterProps } from "../../lib";
import { EnumMultiselectFilter } from "../EnumMultiselectFilter/EnumMultiselectFilter";

const progressStatuses = Object.values(CloseProgressStatus);

export const ProgressFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <EnumMultiselectFilter
        values={progressStatuses}
        labels={closeProgressStatusLabels}
        value={filters.progressStatuses}
        name="progressStatuses"
        onChange={(selected) => onChange({ progressStatuses: selected })}
    />
);
